import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import { Layout } from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Transactions from "@/pages/Transactions";
import Trends from "@/pages/Trends";
import { Loader2 } from "lucide-react";

function Shell() {
  const { ready } = useApp();
  if (!ready) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-muted-foreground bg-[#0a0e14]">
        <Loader2 className="w-8 h-8 animate-spin text-[#f97316]" />
        <p className="font-heading">Loading your budget…</p>
      </div>
    );
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/trends" element={<Trends />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <AppProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AppProvider>
    </div>
  );
}

export default App;
